import { render, staticRenderFns } from "./CoinNetworkAcceptanceModal.vue?vue&type=template&id=3162a6ce&scoped=true&"
import script from "./CoinNetworkAcceptanceModal.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkAcceptanceModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkAcceptanceModal.vue?vue&type=style&index=0&id=3162a6ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162a6ce",
  null
  
)

export default component.exports